import { render, staticRenderFns } from "./category-details.vue?vue&type=template&id=d3f00360&scoped=true&"
import script from "./category-details.vue?vue&type=script&lang=js&"
export * from "./category-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f00360",
  null
  
)

export default component.exports